import React from "react";
import { Clock, XCircle } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/context/I18nContext";
import { SelfDeleteButton } from "@/components/ProfilePanel";
import { DataExportButton } from "@/components/DataExportCard";

export const PendingAccountNotice = () => {
  const { user, logout, refreshMe } = useAuth();
  const { t } = useI18n();
  const rejected = user.account_status === "rejected";
  const Icon = rejected ? XCircle : Clock;
  return (
    <div className="mx-auto max-w-xl py-16" data-testid="pending-account-notice">
      <Card className="border-border">
        <CardContent className="space-y-4 p-8">
          <Icon className={`h-10 w-10 ${rejected ? "text-destructive" : "text-primary"}`} />
          <h1 className="text-2xl font-bold tracking-tight">{t(rejected ? "account_rejected_title" : "account_pending_title")}</h1>
          <p className="text-sm text-muted-foreground" data-testid="pending-account-text">
            {t(rejected ? "account_rejected_text" : user.account_status === "pending_assignment" ? "account_pending_assignment_text" : "account_pending_approval_text")}
          </p>
          {user.address && <p className="font-mono-jb text-sm" data-testid="pending-account-address">{user.address}</p>}
          <div className="flex flex-wrap gap-2">
            {!rejected && (
              <Button variant="outline" onClick={() => refreshMe()} data-testid="pending-refresh-btn">{t("check_again")}</Button>
            )}
            <Button variant="ghost" onClick={() => logout()} data-testid="pending-logout-btn">{t("logout")}</Button>
            <DataExportButton variant="ghost" />
            {user.role === "pool_owner" && <SelfDeleteButton variant="ghost" />}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
